/*eslint-disable*/
import '../App.css';
import '../Section.css';
import '../reset.css'
import '../seik-style.css'
import $ from 'jquery';
import { useState, useEffect } from "react"
import 'animate.css';

function Section3() {

    useEffect(() => {
        handelClickType(0)
        handelClickTypeM(0)
    }, [])

    const animateCSS = (element, animation, elementIndex, delay) => {
        $(element).eq(elementIndex).removeClass(function (index, className) {
            // 정규 표현식을 사용하여 "animate__"로 시작하는 모든 클래스 제거
            return (className.match(/(^|\s)animate\S+/g) || []).join(' ');
        });

        setTimeout(() => {
            $(element).eq(elementIndex).addClass(["animate__animated", animation])
        }, 10)
    };

    let [type, setType] = useState(0)
    let [type2, setType2] = useState(0)

    // const vList = [`${process.env.PUBLIC_URL}/canyon.webm`,`${process.env.PUBLIC_URL}/bitingWind.webm`,`${process.env.PUBLIC_URL}/bitingWind.webm`]

    const typeList = [["canyon", "최고의 인기 게임 모드", "공격로에서 상대를 격파하고 5:5 팀 전투에 뛰어들어 적 넥서스를 파괴해 보세요.", "소환사의 협곡"],
    ["bitingWind", "모두 무작위, 단일 공격로", "얼어붙은 다리 위에서 펼쳐지는 박진감 넘치는 5:5 게임 모드입니다. 무작위 챔피언으로 팀을 구성해 적의 넥서스를 파괴해 보세요.", "무작위 총력전"],
    ["tft", "8인 난투전", "챔피언들로 전략적인 팀을 구성해 결투장으로 진격시키세요. 총 7명의 상대와 겨루어 끝까지 살아남아야 합니다.", "전략적 팀 전투",]]

    const topOffset = [["50px", "100px", "150px"], ["-50px", "0px", "50px"], ["-150px", "-100px", "-50px"]]

    const handelClickType = (index) => {
        switch (index) {
            case 0:
                $("#vod1, #vod2").animate({ opacity: 0 });
                $("#vod0").animate({ opacity: 1 });
                break;
            case 1:
                $("#vod0, #vod2").animate({ opacity: 0 });
                $("#vod1").animate({ opacity: 1 });
                break;
            default:
                $("#vod0, #vod1").animate({ opacity: 0 });
                $("#vod2").animate({ opacity: 1 });
                break;
        }

        if (index > type) {
            animateCSS(".type_bg_box", "animate__fadeOutBottomLeft", type)
            animateCSS(".type_bg_box", "animate__fadeInTopRight", index)
        } else if (index < type) {
            animateCSS(".type_bg_box", "animate__fadeOutBottomRight", type)
            animateCSS(".type_bg_box", "animate__fadeInTopLeft", index)
        } else {
            animateCSS(".type_bg_box", "animate__fadeInTopLeft", index)
        }

        $(".type_box .center").eq(type).stop().animate({ width: "73px", height: "73px" }, 800)
        $(".type_box img").eq(type).stop().animate({ width: "70px" }, 800)
        $(".type_box").eq(type).css({ color: "#fff" })


        $(".type_box .center").eq(index).stop().animate({ width: "105px", height: "105px" }, 800)
        $(".type_box img").eq(index).stop().animate({ width: "99px" }, 800)
        $(".type_box").eq(index).css({ color: "#000" })

        // 배경효과
        setType(index);
        $("#type_bg2").animate({ opacity: 0 }, function () {
            setType2(index);
            $("#type_bg2").animate({ opacity: 1 })
        })
    };

    // 모바일
    const handelClickTypeM = (index) => {
        switch (index) {
            case 0:
                $("#vod1, #vod2").animate({ opacity: 0 });
                $("#vod0").animate({ opacity: 1 });
                $("#mobile").css({ left: "73%" })
                break;
            case 1:
                $("#vod0, #vod2").animate({ opacity: 0 });
                $("#vod1").animate({ opacity: 1 });
                $("#mobile").css({ left: "50%" })
                break;
            default:
                $("#vod0, #vod1").animate({ opacity: 0 });
                $("#vod2").animate({ opacity: 1 });
                $("#mobile").css({ left: "27%" })
                break;
        }

        $("#mobile .type_box .center").eq(type).stop().animate({ width: "63px", height: "63px" }, 800)
        $("#mobile .type_box img").eq(type).stop().animate({ width: "60px" }, 800)
        $("#mobile .type_box p").eq(type).css({ opacity: 0 })

        $("#mobile .type_box .center").eq(index).stop().animate({ width: "83px", height: "83px" }, 800)
        $("#mobile .type_box img").eq(index).stop().animate({ width: "80px" }, 800)
        $("#mobile .type_box p").eq(index).css({ opacity: "1" })

        // 배경효과
        setType(index);
        $("#type_bg2").animate({ opacity: 0 }, function () {
            setType2(index);
            $("#type_bg2").animate({ opacity: 1 })
        })
    };


    return (
        <div className="section section3">
            <p className='title' style={{ left: "-70px", top: "50%", color: "#fff" }}>-&nbsp;게임 모드&nbsp;-</p>
            <img id='type_bg1' src={`${process.env.PUBLIC_URL}/${typeList[type][0]}3.png`} style={{ width: "100%", objectFit: "cover", zIndex: "-5", position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }} alt="Canyon Background" />
            <img id='type_bg2' src={`${process.env.PUBLIC_URL}/${typeList[type2][0]}3.png`} style={{ width: "100%", objectFit: "cover", zIndex: "-5", position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }} alt="Canyon Background" />
            <div className='pc_p' style={{  }}>
                <p style={{ margin: 0 }}>{typeList[type][1]}</p>
                <p id='pc' >{typeList[type][2]}</p>
            </div>
            <div className='mb'>
                <div className='section_box animate__animated animate__fadeInDown'>
                    <h3 style={{ fontSize: "20px", color: "#fff" }}>다양하게</h3>
                    <h2 style={{ fontSize: "50px", color: "#fff" }}>플레이</h2>
                    <a className='play_box_long animate__animated animate__fadeIn' style={{ animationDelay: '0.4s', width: "170px" }} href=''>지금 플레이하기</a>
                </div>
            </div>
            <div className="section3_box">
                <div id='pc' className='section_box animate__animated animate__fadeInDown'>
                    <h3 style={{ fontSize: "20px" }}>다양하게</h3>
                    <h2 style={{ fontSize: "55px" }}>플레이</h2>
                    <a className='play_box_long animate__animated animate__fadeIn' style={{ animationDelay: '0.4s', width: "170px" }} href=''>지금 플레이하기</a>
                </div>
                <div id='pc' style={{ width: "35%" }}></div>
                <div id='pc'>
                    {
                        typeList.map(([typeE, txt1, txt2, typeK], index) => {

                            return (
                                <div className='type_box' key={index} style={{ top: `${topOffset[type][index]}` }} onClick={() => handelClickType(index)}>
                                    <p style={{ width: "150px", fontSize: "12px", position: "absolute", right: "50%", top: "50%", transform: "translate(20%, -50%)" }}>{typeK}</p>
                                    <div id='type_box_div' className='center' style={{ width: "73px", height: "73px", backgroundColor: "#0bc6e3", position: "absolute", left: "50%", top: "50%", transform: "translate(0%, -50%)" }}>
                                        <img style={{ width: "70px" }} src={`${process.env.PUBLIC_URL}/${typeE}.jpg`} alt={typeE} />
                                    </div>
                                    <div className='type_bg_box'></div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className='center' id='mobile'>
                    {
                        typeList.map(([typeE, txt1, txt2, typeK], index) => {

                            return (
                                <div className='type_box' key={index} onClick={() => handelClickTypeM(index)}>
                                    <p>{typeK}</p>
                                    <div id='type_box_div' className='center' style={{ width: "63px", height: "63px", backgroundColor: "#0bc6e3", margin: "auto" }}>
                                        <img style={{ width: "60px" }} src={`${process.env.PUBLIC_URL}/${typeE}.jpg`} alt={typeE} />
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
            <div>
                {
                    typeList.map((item, index) => {
                        return (
                            <div id={`vod${index}`} className={"vod"} key={index}>
                                <video height="500px" controls={false} muted autoPlay loop style={{ objectFit: "cover" }}>
                                    <source src={`${process.env.PUBLIC_URL}/${item[0]}.webm`} type="video/mp4" />
                                </video>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Section3